<div class="close-row"><i (click)="closeDialog()" class="material-icons close">close</i></div>
<p>
  Looks like you've got cookies disabled. In order to get the most out of Rollit's web services we require them to be enabled. <a href="https://www.whatismybrowser.com/guides/how-to-enable-cookies/" target="_blank">Find out how</a>.
</p>
